export default __webpack_public_path__ + "static/media/requesticonactive.e944103c.svg";